var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("gwas-toolbar", {
            attrs: {
              batch_region_getter: _vm.fetchTopHits,
              genome_build: _vm.genome_build,
              max_studies: 6,
              known_tracks: _vm.known_tracks,
            },
            on: {
              "update:genome_build": function ($event) {
                _vm.genome_build = $event
              },
              "add-tabix-track": _vm.receiveTrackOptions,
              "select-range": _vm.updateRegion,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("plot-panes", {
            ref: "plotWidget",
            attrs: {
              dynamic_urls: true,
              base_layout: _vm.lz_layout,
              base_sources: _vm.lz_sources,
              known_tracks: _vm.known_tracks,
              genome_build: _vm.genome_build,
              chr: _vm.c_chr,
              start: _vm.c_start,
              end: _vm.c_end,
            },
            on: { "plot-created": _vm.activateMetrics },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }